// Core
import { useMemo, useState } from 'react';
import { NavLink } from 'react-router-dom';
import { Box, Text, Flex, Image, Grid, useColorModeValue } from '@chakra-ui/react';
import { RxArrowTopRight } from 'react-icons/rx';

// Assets
import { ReactComponent as WarningIcon } from 'assets/svg/warning-v2.svg';

// Components
import Card from 'components/Card/Card';

export default function Warning (props) {
  const textColor = useColorModeValue('', '#9FABCB');
  const bgColor = useColorModeValue('rgba(255, 247, 217, 0.50)', 'rgba(24, 23, 16, 0.50)');

  return (
    <>
    	<Card 
          bg={bgColor}
          borderRadius="16px"
          maxW={props.maxW ?? '100%'}
          mt={props.mt ?? 'unset'}
          m={props.m ?? 'unset'}
          variant="ghost" 
          padding='12px 16px'
          backdropFilter="blur(15px)" 
          border="1px solid #FF6C64"
          mb={{ base: '12px', md: '16px' }}>
            <Flex alignItems="center" gap="12px">
              <Box w="24px"><WarningIcon fontSize="24px" /></Box>
              <Text maxW={{base: '100%'}} variant="text-md" color={textColor}>
  			         {typeof props.text === 'string' ? `${props.text}` : 'Warning'}
              </Text>
            </Flex>
        </Card>
    </>
  );
}